export default __webpack_public_path__ + "static/media/Minicard_8c.8e3e4ff9.svg";